"use client";
import { useRef } from "react";
import Image from "next/image";
import EnrollTourButtons from "@/components/cms/EnrollTourButtons";
import { useParallaxOffset } from "@/hooks/useParallaxOffset";
import { motion } from "framer-motion";

export default function ThreeColumns({ cms }: { cms?: Record<string, string> }) {
  const parallaxRef = useRef<HTMLDivElement>(null);

  // Use optimized parallax hook
  const [offset, isDesktop, transform3d] = useParallaxOffset(0.2, 640, parallaxRef);

  const bgImage =
    cms?.bg_image_url ?? "";
    // || "https://muqh1zzqjnwuke9n.public.blob.vercel-storage.com/about/IMG-1234.webp"
  return (
    <section className="relative min-h-[90vh] flex items-center font-nunito py-24">
      <div className="absolute inset-0 overflow-hidden">
        <div
          ref={parallaxRef}
          className="will-change-transform"
          style={{
            top: "-45%",
            height: "190%",
            width: "100%",
            position: "absolute",
            aspectRatio: "4/3", // Prevent CLS
            transform: isDesktop ? transform3d : undefined,
          }}
        >
          <Image
            src={bgImage}
            alt="Students playing"
            fill
            sizes="100vw"
            priority
            className="object-cover object-[center_-495px]"
          />
        </div>
        <div
          className="absolute inset-0"
          style={{ backgroundColor: "rgba(12, 22, 71, 0.6)" }}
        ></div>
      </div>
      <div className="relative z-10 container mx-auto px-4 flex flex-col justify-center h-full">
        <div className="grid md:grid-cols-3 gap-12 text-white">
          <div className="text-center">
            <motion.h3
              className="text-2xl sm:text-3xl md:text-4xl font-bold mb-24 text-school-gold"
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, margin: "-100px 0px -100px 0px" }}
              transition={{ type: "spring", stiffness: 120, damping: 20 }}
            >
              {cms?.col1_title /* || "Our All-Inclusive approach to Education" */}
            </motion.h3>
            <p className="mb-6 text-base sm:text-lg font-semibold">
              {cms?.col1_para1 ||
                /* "Ashton John\u2019s brings the Cambridge Curriculum to Klerksdorp, with a special emphasis on Perceptual skills, Numeracy, Literacy, Life skills, and Science." */
                undefined}
            </p>
            <p className="text-base sm:text-lg font-semibold">
              {cms?.col1_para2 ||
                /* "The Cambridge Curriculum is internationally recognised and top five recognised globally." */
                undefined}
            </p>
          </div>
          <div className="text-center">
            <motion.h3
              className="text-2xl sm:text-3xl md:text-4xl font-bold mb-24 text-school-gold"
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, margin: "-100px 0px -100px 0px" }}
              transition={{ type: "spring", stiffness: 120, damping: 20 }}
            >
              {cms?.col2_title /* || "Student Development" */}
            </motion.h3>
            <p className="mb-6 text-base sm:text-lg font-semibold">
              {cms?.col2_para1 ||
                /* "We encourage students to develop higher-order thinking skills, problem-solving, and critical thinking skills." */
                undefined}
            </p>
            <p className="text-base sm:text-lg font-semibold">
              {cms?.col2_para2 ||
                /* "Our teachers endorse independent research, collaboration, and presenting debates." */
                undefined}
            </p>
          </div>
          <div className="text-center">
            <motion.h3
              className="text-2xl sm:text-3xl md:text-4xl font-bold mb-24 text-school-gold"
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, margin: "-100px 0px -100px 0px" }}
              transition={{ type: "spring", stiffness: 120, damping: 20 }}
            >
              {cms?.col3_title /* || "Student Pledge" */}
            </motion.h3>
            <p className="mb-6 text-base sm:text-lg font-semibold">
              {cms?.col3_para1 /* || "We pledge to treat one another with dignity." */}
            </p>
            <p className="text-base sm:text-lg font-semibold">
              {cms?.col3_para2 ||
                /* "I will speak and behave courteously, cooperate with my fellow students and teachers, develop positive and respectful relationships, think about the effect on relationships before acting, and value the interests, abilities, and culture of others." */
                undefined}
            </p>
          </div>
        </div>
        <EnrollTourButtons
          className="flex flex-col sm:flex-row gap-4 justify-center items-center mt-32"
          buttonClassName="bg-school-gold hover:bg-school-gold-dark text-black font-bold py-4 px-8 rounded text-lg transition-colors text-center"
          enrollText="ENROL NOW"
          tourText="BOOK A TOUR"
        />
      </div>
    </section>
  );
}
